import Vue from 'vue'
import { Button } from 'vant'
import { Cell, CellGroup } from 'vant';
import { Icon } from 'vant'
import { Popup } from 'vant'
import { Checkbox, CheckboxGroup } from 'vant';
import { RadioGroup, Radio } from 'vant';
import { Field } from 'vant'
import { Picker } from 'vant';
import { Search } from 'vant';
import { Stepper } from 'vant';
import { Switch } from 'vant';
import { Dialog } from 'vant'
import { Loading } from 'vant'
import { PullRefresh } from 'vant';
import { SwipeCell } from 'vant';
import { Toast } from 'vant'
import { ImagePreview } from 'vant';
import { Circle } from 'vant';
import { Collapse, CollapseItem } from 'vant'
import { List } from 'vant';
import { Step, Steps } from 'vant'
import { Swipe, SwipeItem } from 'vant'
import { Lazyload } from 'vant';
import { Tab, Tabs } from 'vant';
import { Tabbar, TabbarItem } from 'vant';
import { NoticeBar } from 'vant';
import { Badge } from 'vant';
import { Skeleton } from 'vant';
import { Uploader, Progress } from 'vant';
import { ActionSheet } from 'vant';
import { DatetimePicker } from 'vant';
import { Empty } from 'vant';
import { DropdownMenu, DropdownItem } from 'vant';
import { Popover, Overlay, NumberKeyboard, Sku, NavBar, Card } from 'vant'
import { GoodsAction, GoodsActionIcon, GoodsActionButton } from 'vant';

Vue.use(Card)
Vue.use(NavBar)
Vue.use(GoodsAction);
Vue.use(GoodsActionButton);
Vue.use(GoodsActionIcon);
Vue.use(Sku)
Vue.use(NumberKeyboard)
Vue.use(Popover)
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Empty);
Vue.use(DatetimePicker);
Vue.use(ActionSheet);
Vue.use(Progress)
Vue.use(Uploader);
Vue.use(Skeleton);
Vue.use(Badge)
Vue.use(Button);
Vue.use(Cell).use(CellGroup);
Vue.use(Icon);
Vue.use(Popup);
Vue.use(Checkbox).use(CheckboxGroup);
Vue.use(Radio).use(RadioGroup);
Vue.use(Field);
Vue.use(Picker);
Vue.use(Search);
Vue.use(Stepper);
Vue.use(Switch);
Vue.use(Dialog);
Vue.use(Loading);
Vue.use(PullRefresh);
Vue.use(SwipeCell);
Vue.use(Toast);
Vue.use(Swipe).use(SwipeItem);
Vue.use(ImagePreview);
Vue.use(Tab).use(Tabs);
Vue.use(Collapse).use(CollapseItem);
Vue.use(Tabbar).use(TabbarItem);
Vue.use(List)
Vue.use(Lazyload);
Vue.use(NoticeBar);
Vue.use(Circle)
Vue.use(Overlay)


Vue.use(Step);
Vue.use(Steps);


// WEBPACK FOOTER //
// ./src/assets/js/vant.js